import React from "react";
import { withRouter } from "react-router-dom";
import { GetData } from "../data-context";

const Settings = (props) => {
  
  const { settings, setSettings, restoreSettings } = GetData();

  const { options, minValue, maxValue, icons } = settings;

  const setValue = (option, flow, idx) => {
    let currentValue = settings[option];
    if (flow === "up") {
      if (currentValue < maxValue[idx]) currentValue++;
    } else {
      if (currentValue > minValue[idx]) currentValue--;
    }
    setSettings({ ...settings, [option]: currentValue });
  };

  const apply = () => {
    props.history.push("/players");
  };

  return (
    <div className="d-flex flex-column justify-content-center">
      <h5 className="text-blink text-mk">FIGHT SETTINGS</h5>
      <div className="container rounded p-2 col-7 settings-bg">
        {options.map((option, idx) => {
          return (
            <Option
              key={idx}
              option={option}
              icon={icons[idx]}
              value={settings[option]}
              setValue={(flow) => setValue(option, flow, idx)}
            />
          );
        })}

        <div className="w-100 bg-dark d-flex justify-content-center p-3 mb-0">
          <button className="flex-1 mr-3 btn btn-secondary" onClick={apply}>
            <span className="text-mk settings-shadows"><i className="fas fa-check mr-2"/>DONE!</span>
          </button>
          <button className="flex-1 btn btn-secondary" onClick={restoreSettings}>
            <span className="text-mk settings-shadows"><i className="fas fa-undo mr-2"/>RESTORE</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Settings);

const Option = (props) => {
  return (
    <div className="d-flex justify-content-between align-items-center">
      <h6 className="settings-shadows text-left text-uppercase text-gothic flex-1">
        <i className={`fas fa-${props.icon} mr-2`} /> {props.option}
      </h6>
      <div className="d-flex align-items-center">
        <h5 className="text-warning settings-shadows text-mk">{props.value}</h5>
        <div className="ml-3">
          <i className="d-block display-6 my-1 fas fa-caret-square-up text-dark" onClick={() => props.setValue("up")} />

          <i className="d-block display-6 my-1 fas fa-caret-square-down text-dark" onClick={() => props.setValue("down")} />
        </div>
      </div>
    </div>
  );
};
